import { Component, OnInit, Inject, LOCALE_ID, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs';
import { formatDate } from '@angular/common';
import { InvoiceService } from "../services/invoice-service.service";
import { AlertService } from "../../core/alert.service";

@Component({
  selector: 'app-send-multiple-invoice',
  templateUrl: './send-multiple-invoice.component.html',
  styleUrls: ['./send-multiple-invoice.component.scss']
})
export class SendMultipleInvoiceComponent implements OnInit {
  @Input() customerId: number;
  @Input() customerName: string;

  busy: boolean = false;
  invoiceDataSource: BehaviorSubject<any[]>;
  invoiceColumns: any[];
  private gridApi;
  selectedRowsString = '';

  constructor(private modalRef: NgbActiveModal,
    private invoiceService: InvoiceService,
    private alert: AlertService,
    @Inject(LOCALE_ID) private locale: string) {

    this.invoiceDataSource = new BehaviorSubject([]);
    this.invoiceColumns = [
      {
        headerName: 'Invoice Number',
        field: 'invoiceNumber',
        sortable: true,
        filter: true,
        width: 300,
        cellRenderer: this.sourceRenderer.bind(this),
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
      },
      {
        headerName: 'Payment Term',
        field: 'paymentTerm',
        sortable: true,
        filter: true,
        valueGetter: params => {
          return `${params.data.paymentTermValue} - ${params.data.paymentTerm}`;
        }
      },
      { headerName: 'Due Date', field: 'dueDate', sortable: true, filter: 'agDateColumnFilter', cellRenderer: this.dateRenderer.bind(this) },
      { headerName: 'Status', field: 'status', sortable: true, filter: true, cellRenderer: this.statusRenderer.bind(this) },
      { headerName: 'Amount Due', field: 'balance', sortable: true, filter: true, cellRenderer: function(params: any){
        return `<strong>$ ${(params.data.balance).toFixed(2)} </strong>`;
      }
    },
    ];
  }

  loadInvoice(){
    this.busy = true;
    this.invoiceService.getCustomerManualInvoicesByStatus(this.customerId, 'AllActive').subscribe((res:any) => {
      if(res) {
        this.invoiceDataSource.next(res.result);
      }
      this.busy = false;
    });
  }

  onSelectionChanged() {
    this.selectedRowsString = '';

    var selectedRows = this.gridApi.getSelectedRows();
    var selectedRowStr = '';
    selectedRows.forEach(function(selectedRow, index) {
      if (index > 0) {
        selectedRowStr += ',';
      }
      selectedRowStr += selectedRow.invoiceNumber;
    });
    this.selectedRowsString = selectedRowStr;
  }

  private dateRenderer(params) {
    let data = params.data;
    let dueDate = data.dueDate;
    if(!dueDate || dueDate === '0001-01-01T00:00:00') {
      return 'N / A';
    } else {
      return formatDate(data.dueDate, 'yyyy-MM-dd', this.locale);
    }
  }

  private statusRenderer(params){
    let statClass = '';
    let status = params.data.status;

    if (status === 'New' && params.data.isDraft) {
      status = 'Draft'
    }

    switch (status) {
      case 'New': statClass = 'badge badge-info'
        break;
      case 'Draft': statClass = 'text-secondary'
        break;
        case 'Partial':
      case 'Partially Paid': statClass = 'badge badge-warning'
        break;
      case 'Paid':
      case 'Fully Paid': statClass = 'badge badge-success'
        break;
      case 'Voided': statClass = 'badge badge-dark'
        break;
      case 'Refunded': statClass = 'badge badge-secondary'
        break;
      case 'Overdue': statClass = 'badge badge-danger'
        break;
      case 'Viewed':statClass = 'badge badge-viewed'
        break;
      case 'Sent': statClass = 'badge badge-sent'
        break;
    }
    return `<strong class="${statClass} badge-pill" style="text-transform: uppercase!important;">${status}</strong>`;
  }

  private sourceRenderer(params){
    let statClass = '';
    let source = params.data.source;

    switch (source) {
      case 'Estimate':
        statClass = 'invoice-source invoice-source-mi'
        break;
      case 'Work Order':
        statClass = 'invoice-source invoice-source-es'
        break;
      case 'Manual Invoice':
        statClass = 'invoice-source invoice-source-wo'
        source = 'MI'
        break;
      case 'Recurring Invoice':
        statClass = 'invoice-source invoice-source-ri'
        source = 'RI';
        break;
      case 'Recurring Payment':
        statClass = 'invoice-source invoice-source-rp'
        source = 'RP';
        break;
    }

    return `<div><div class="${statClass}" style="float:left;text-transform: uppercase!important;" title="${params.data.source}" aria-label="${params.data.source}">${source.substring(0,2)}</div> ${params.data.invoiceNumber}</div>`;
  }

  ngOnInit() {
    this.loadInvoice();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    // this.gridApi.sizeColumnsToFit();
    this.gridApi.setDomLayout('autoHeight');
  }

  onSend(){
    this.busy = true;
    this.invoiceService.sendmultipleinvoices(this.selectedRowsString.split(',')).subscribe((res:any) => {
      if(res) {
        this.alert.alertSuccess({ title: 'Success!', text: 'Invoice has been successfully sent!' });
      this.busy = false;
      }
      this.busy = false;
    });
  }

  close(data?: any) {
    this.modalRef.close(data);
  }

}
